export default __webpack_public_path__ + "static/media/grubdash_screen.c32ab344.png";